import { createElement } from "react";
import { LABELS, LABEL_OVERRIDES, TEMPLATES, LONG } from "@/components/admin/labels";
import { ImageField } from "@/components/admin/ImageField";
import { BlockedDates } from "@/components/admin/BlockedDates";
import { MultiUpload, PositionField, PhotoList } from "@/components/admin/GalleryTools";

const lab = (k, path) => LABEL_OVERRIDES[path.replace(/\.\d+/g, "")] || LABELS[k] || k;
const tid = (path) => `field-${path.replace(/\./g, "-")}`;

const MULTI = { "gallery.items": "gallery-multi-upload", "instagram.items": "instagram-multi-upload" };

const move = (arr, i, d) => { const a = [...arr]; [a[i], a[i + d]] = [a[i + d], a[i]]; return a; };

const ItemTools = ({ arr, i, onChange }) => (
  <div className="fe-actions">
    <button type="button" className="mini" disabled={i === 0} onClick={() => onChange(move(arr, i, -1))} aria-label="W górę">↑</button>
    <button type="button" className="mini" disabled={i === arr.length - 1} onClick={() => onChange(move(arr, i, 1))} aria-label="W dół">↓</button>
    <button type="button" className="mini danger" onClick={() => onChange(arr.filter((_, j) => j !== i))}>Usuń</button>
  </div>
);

const StringList = ({ k, path, value, onChange }) => (
  <div className="fe-field">
    <label>{lab(k, path)}</label>
    {value.map((s, i) => (
      <div className="fe-row" key={i}>
        <input value={s} onChange={(e) => onChange(value.map((x, j) => (j === i ? e.target.value : x)))} data-testid={`${tid(path)}-${i}`} />
        <ItemTools arr={value} i={i} onChange={onChange} />
      </div>
    ))}
    <button type="button" className="mini" style={{ justifySelf: "start" }} onClick={() => onChange([...value, ""])} data-testid={`${tid(path)}-add`}>+ Dodaj</button>
  </div>
);

const ObjectList = ({ k, path, value, onChange }) => {
  const tpl = TEMPLATES[path.split(".").slice(-2).join(".")] || TEMPLATES[k] || {};
  return (
    <div className="fe-field">
      <label>{lab(k, path)}</label>
      <div className="fe">
        {value.map((item, i) => (
          <div className="fe-group" key={i} data-testid={`${tid(path)}-item-${i}`}>
            <div className="fe-head"><span className="label">#{i + 1} {item.title || item.name || item.q || ""}</span><ItemTools arr={value} i={i} onChange={onChange} /></div>
            {createElement(ObjectFields, { path: `${path}.${i}`, value: item, onChange: (v) => onChange(value.map((x, j) => (j === i ? v : x))) })}
          </div>
        ))}
      </div>
      <div className="fe-actions" style={{ flexWrap: "wrap" }}>
        <button type="button" className="mini" onClick={() => onChange([...value, JSON.parse(JSON.stringify(tpl))])} data-testid={`${tid(path)}-add`}>+ Dodaj element</button>
        {MULTI[path] && <MultiUpload value={value} onChange={onChange} tpl={tpl} testid={MULTI[path]} />}
      </div>
    </div>
  );
};

const isStringList = (k, path, value) =>
  value.length ? typeof value[0] === "string" : !TEMPLATES[k] && !TEMPLATES[path.split(".").slice(-2).join(".")];

const TextField = ({ k, path, value, onChange }) => {
  const long = LONG.includes(k) || (value || "").length > 90;
  const props = { value: value || "", onChange: (e) => onChange(e.target.value), "data-testid": tid(path) };
  return <div className="fe-field"><label>{lab(k, path)}</label>{long ? <textarea {...props} /> : <input {...props} />}</div>;
};

const BoolField = ({ k, path, value, onChange }) => (
  <label className="check"><input type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} data-testid={tid(path)} />{lab(k, path)}</label>
);

const NumberField = ({ k, path, value, onChange }) => (
  <div className="fe-field"><label>{lab(k, path)}</label><input type="number" min="0" value={value} onChange={(e) => onChange(Number(e.target.value))} data-testid={tid(path)} /></div>
);

const pickEditor = (k, path, value) => {
  if (k === "blocked") return BlockedDates;
  if (k === "image") return ImageField;
  if (k === "position") return PositionField;
  if (k === "photos") return PhotoList;
  if (typeof value === "boolean") return BoolField;
  if (typeof value === "number") return NumberField;
  if (Array.isArray(value)) return isStringList(k, path, value) ? StringList : ObjectList;
  if (value && typeof value === "object") return ObjectFields;
  return TextField;
};

export const Field = (props) => {
  const Editor = pickEditor(props.k, props.path, props.value);
  return createElement(Editor, { ...props, label: lab(props.k, props.path), testid: tid(props.path) });
};

export const ObjectFields = ({ path, value, onChange }) => (
  <div className="fe">
    {Object.entries(value).map(([k, v]) => (
      createElement(Field, { key: k, k, path: `${path}.${k}`, value: v, siblings: value, onChange: (nv) => onChange({ ...value, [k]: nv }) })
    ))}
  </div>
);
